import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { orderBusiness } from "api/bussiness/order/order-bussiness";
import { downloadFile } from "commons/ultilities";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useMemo } from "react";
import { DateRange } from "share-components/atomics/date-range";
import { ExportExcelDialog } from "share-components/mui-wrap/dialog/export-excel-dialog";

export const ExportExcel = observer(() => {
  const {
    orderManagement: {
      excelParams: {
        poDateRangeFilter: {
          from,
          to,
          fromAsDayJs,
          toAsDayJs,
          setProp: setPODateRange,
        },
        showSuccess,
        setProp: setExcelParams,
      },
      openExportExcel,
      setProp,
    },
  } = useStores();
  const handleClose = () => {
    setProp("openExportExcel", false);
  };

  const fromPODateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setPODateRange("from", value ? value.toString() : null);
    },
    [setPODateRange]
  );

  const toPODateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setPODateRange("to", value ? value.toString() : null);
    },
    [setPODateRange]
  );

  const exportBtnDisabled = useMemo(() => {
    if (!fromAsDayJs || !toAsDayJs) {
      return true;
    }
  }, [fromAsDayJs, toAsDayJs]);

  const exportExcel = useCallback(async () => {
    try {
      const res = await orderBusiness.exportExcel(
        fromAsDayJs?.isValid() && from ? from : "",
        toAsDayJs?.isValid && to ? to : "",
        showSuccess
      );
      downloadFile(
        res,
        `Don_Dat_Hang_tu_${dateTimeDisplay(from)}_den_${dateTimeDisplay(
          to
        )}.xlsx`
      );
    } catch (ex) {
    } finally {
    }
  }, [from, fromAsDayJs, showSuccess, to, toAsDayJs?.isValid]);
  return (
    <ExportExcelDialog
      open={openExportExcel}
      handleClose={handleClose}
      exportHandler={exportExcel}
      exportBtnDisabled={exportBtnDisabled}
    >
      <Stack direction={"row"} spacing={2} sx={{ paddingTop: 1 }}>
        <DateRange
          label={"Ngày PO"}
          fromDate={fromAsDayJs}
          toDate={toAsDayJs}
          onFromDateChanged={fromPODateChangedHandler}
          onToDateChanged={toPODateChangedHandler}
        ></DateRange>
      </Stack>
      <Stack marginTop={"16px"}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showSuccess}
              onChange={(_, checked) => setExcelParams("showSuccess", checked)}
            />
          }
          label="Gồm các đơn hoàn thành"
        />
      </Stack>
    </ExportExcelDialog>
  );
});
